namespace advisorop.components.widgets {
    
    export class TopClientsController{
        public model: domains.IChartDataSource;
        public dg;
        n: number;
        public asOfDate;
        
        constructor(private advisorService: services.AdvisorService, private $rootScope: ng.IRootScopeService) { 
            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.loadTopNClients();
            });                       
            this.dg = {
                export: {
                    enabled: true,
                    fileName: "TopClients"
                },
                bindingOptions: {
                    dataSource: "vm.model.data"
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                stateStoring: {
                    enabled: false,
                    type: "localStorage",
                    storageKey: "dgTOPNClients"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'label', caption: 'Client or Entity Name', cellTemplate: 'colFullName'},
                    { dataField: 'value', caption: 'USD Value', width: 110, format: { type: 'fixedPoint', precision: 2 } }
                ]
            };            
        }

        loadTopNClients()
        {
            // console.log(`Loading TopNClients n:${this.n}, asOfDate:${this.asOfDate}`);
            const adminMode = this.advisorService.getAdminMode();
            const adminModeEnabled = adminMode && adminMode.enabled;
            this.advisorService.getTopNClients(adminModeEnabled, this.n, adminModeEnabled && adminMode.advisoryFirm ? adminMode.advisoryFirm.id : null)
                .then(data => {
                    this.model = data.data;
                    this.asOfDate = this.model.asOfDt;
            }, err => toastr.error("TOP N Clients error: " + err.status + ":" + err.data));
        }
        
        $onInit(): void {
            if (!this.n) {
                this.loadTopNClients();
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "n") {
                    if (this.n) {
                        this.loadTopNClients();
                    }
                }
            }
        }

        $routerOnActivate(next, previous) {
            
        }

    }



    class TopClients implements ng.IComponentOptions {

        public transclude: boolean;
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                n: "<",
                asOfDate: "="
            };
            this.controller = ["advisorService","$rootScope", TopClientsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/top-clients.html';
            this.transclude = false;
        }
    }
    angular.module(Constants.APP).component("topClients", new TopClients());
    
}